import apiClient from "./api";

export const getBranches = async () => {
  const response = await apiClient.get("/branches");
  return response.data.data || [];
};

export const getBranch = async (id) => {
  const response = await apiClient.get(`/branches/${id}`);
  return response.data;
};

export const createBranch = async (branch) => {
  const response = await apiClient.post("/branches", branch);
  return response.data;
};

export const updateBranch = async (id, branch) => {
  const response = await apiClient.put(`/branches/${id}`, branch);
  return response.data;
};

export const deleteBranch = async (id) => {
  const response = await apiClient.delete(`/branches/${id}`);
  return response.data;
};
